(function(){
  'use strict';

  const q=(selector,context=document)=>context.querySelector(selector);
  const qa=(selector,context=document)=>Array.from(context.querySelectorAll(selector));

  const overlay=q('[data-overlay]');
  const searchDrawer=q('[data-search-drawer]');
  const cartDrawer=q('[data-cart-drawer]');

  function escapeHtml(value){
    const div=document.createElement('div');
    div.textContent=value||'';
    return div.innerHTML;
  }

  function formatMoney(cents){
    const currency=(window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat(undefined,{style:'currency',currency}).format((Number(cents)||0)/100);
  }

  function closeDrawers(){
    overlay?.classList.remove('is-open');
    searchDrawer?.classList.remove('is-open');
    cartDrawer?.classList.remove('is-open');
  }

  async function refreshCart(){
    if(!cartDrawer) return;
    try{
      const response=await fetch('/cart.js');
      if(!response.ok) return;
      const cart=await response.json();

      const itemsHost=q('[data-cart-items]',cartDrawer);
      const totalHost=q('[data-cart-total]',cartDrawer);

      if(itemsHost){
        if(cart.items.length){
          itemsHost.innerHTML=cart.items.map(item=>{
            const properties=item.properties || {};
            const propertyLines=Object.keys(properties)
              .filter(key=>properties[key])
              .map(key=>`<small>${escapeHtml(key)}: ${escapeHtml(String(properties[key]))}</small>`)
              .join('');
            return `<div class="tdc-cart-item">
              <strong>${escapeHtml(item.product_title)}</strong>
              ${item.variant_title ? `<div>${escapeHtml(item.variant_title)}</div>` : ''}
              ${propertyLines}
              <small>${formatMoney(item.final_line_price)}</small>
            </div>`;
          }).join('');
        }else{
          itemsHost.innerHTML='<p>Your cart is empty.</p>';
        }
      }

      if(totalHost) totalHost.textContent=formatMoney(cart.total_price);
      qa('[data-cart-count]').forEach(el=>el.textContent=String(cart.item_count));
    }catch(error){}
  }

  function openCart(){
    closeDrawers();
    overlay?.classList.add('is-open');
    cartDrawer?.classList.add('is-open');
    refreshCart();
  }

  // Mobile menu
  const menuButton=q('[data-menu-toggle]');
  const mobileNav=q('[data-mobile-nav]');
  if(menuButton && mobileNav){
    const label=q('.tdc-menu-toggle__label',menuButton);
    menuButton.addEventListener('click',()=>{
      const open=mobileNav.classList.toggle('is-open');
      document.body.classList.toggle('tdc-menu-open',open);
      menuButton.setAttribute('aria-expanded',String(open));
      if(label) label.textContent=open?'Close':'Menu';
    });

    qa('a',mobileNav).forEach(link=>{
      link.addEventListener('click',()=>{
        mobileNav.classList.remove('is-open');
        document.body.classList.remove('tdc-menu-open');
        menuButton.setAttribute('aria-expanded','false');
        if(label) label.textContent='Menu';
      });
    });
  }

  // Utility menu
  const utilityButton=q('[data-utility-toggle]');
  const utilityPopover=q('[data-utility-popover]');
  if(utilityButton && utilityPopover){
    utilityButton.addEventListener('click',event=>{
      event.stopPropagation();
      const open=utilityPopover.classList.toggle('is-open');
      utilityButton.setAttribute('aria-expanded',String(open));
    });
    utilityPopover.addEventListener('click',event=>event.stopPropagation());
    document.addEventListener('click',()=>{
      utilityPopover.classList.remove('is-open');
      utilityButton.setAttribute('aria-expanded','false');
    });
  }

  // Drawers
  qa('[data-search-open]').forEach(button=>{
    button.addEventListener('click',()=>{
      closeDrawers();
      overlay?.classList.add('is-open');
      searchDrawer?.classList.add('is-open');
      setTimeout(()=>q('input[type="search"]',searchDrawer)?.focus(),20);
    });
  });

  qa('[data-cart-open]').forEach(button=>button.addEventListener('click',openCart));
  qa('[data-drawer-close]').forEach(button=>button.addEventListener('click',closeDrawers));
  overlay?.addEventListener('click',closeDrawers);

  // Accordions
  qa('[data-accordion-trigger]').forEach(button=>{
    button.addEventListener('click',()=>{
      const accordion=button.closest('[data-accordion]');
      if(!accordion) return;
      const open=accordion.classList.toggle('is-open');
      button.setAttribute('aria-expanded',String(open));
      const symbol=q('.tdc-accordion-symbol',button);
      if(symbol) symbol.textContent=open?'−':'+';
    });
  });

  // Private training goal chips
  qa('[data-goal]').forEach(button=>{
    button.addEventListener('click',()=>{
      button.classList.toggle('is-selected');
      const form=button.closest('form');
      if(!form) return;
      const hidden=q('[name="contact[Training goals]"]',form);
      if(hidden){
        hidden.value=qa('[data-goal].is-selected',form).map(item=>item.dataset.goal).join(', ');
      }
    });
  });

  // Homepage training cycle
  qa('[data-training-cycle]').forEach(section=>{
    const tabs=qa('[data-training-tab]',section);
    const title=q('[data-detail-title]',section);
    const day=q('[data-detail-day]',section);
    const time=q('[data-detail-time]',section);
    const price=q('[data-detail-price]',section);
    const detailLink=q('[data-detail-link]',section);
    const addButton=q('[data-home-class-add]',section);

    function selectTab(tab){
      tabs.forEach(item=>item.classList.toggle('is-active',item===tab));
      if(title) title.textContent=tab.dataset.title||'';
      if(day) day.textContent=tab.dataset.day||'';
      if(time) time.textContent=tab.dataset.time||'';
      if(price) price.textContent=tab.dataset.price||'';
      if(detailLink) detailLink.href=tab.dataset.url||'/pages/classes';
      if(addButton){
        const variantId=tab.dataset.variantId||'';
        addButton.dataset.variantId=variantId;
        addButton.disabled=!variantId;
      }
    }

    tabs.forEach(tab=>tab.addEventListener('click',()=>selectTab(tab)));
    if(tabs.length) selectTab(tabs[0]);

    addButton?.addEventListener('click',async()=>{
      const variantId=Number(addButton.dataset.variantId);
      if(!variantId) return;
      try{
        const response=await fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:variantId,quantity:1}]})
        });
        if(!response.ok) return;
        openCart();
      }catch(error){}
    });
  });

  // Rolling multi-class calendar
  qa('[data-class-calendar]').forEach(calendar=>{
    const dataScript=q('[data-class-products-json]',calendar);
    const grid=q('[data-calendar-grid]',calendar);
    const summary=q('[data-selected-summary]',calendar);
    const totalHost=q('[data-selected-total]',calendar);
    const addButton=q('[data-add-selected]',calendar);

    if(!dataScript || !grid) return;

    let classes=[];
    try{
      classes=JSON.parse(dataScript.textContent);
    }catch(error){
      return;
    }

    const selected=[];
    const requestedDays=Number(grid.dataset.calendarDays||60);
    const calendarDays=Math.max(30,Math.min(60,requestedDays));
    const today=new Date();
    today.setHours(12,0,0,0);

    function updateSelectionSummary(){
      const total=selected.reduce((sum,item)=>sum+Number(item.price||0),0);
      if(summary) summary.textContent=selected.length?`${selected.length} selected`:'No classes selected';
      if(totalHost) totalHost.textContent=formatMoney(total);
    }

    for(let offset=0;offset<calendarDays;offset++){
      const date=new Date(today);
      date.setDate(today.getDate()+offset);

      const matching=classes.filter(item=>Number(item.weekday)===date.getDay());
      if(!matching.length) continue;

      const day=document.createElement('div');
      day.className='tdc-calendar-day';

      const dateLabel=document.createElement('div');
      dateLabel.className='tdc-calendar-date';
      dateLabel.textContent=date.toLocaleDateString(undefined,{weekday:'short',month:'short',day:'numeric'});
      day.appendChild(dateLabel);

      matching.forEach(item=>{
        const button=document.createElement('button');
        button.type='button';
        button.className='tdc-calendar-event';

        const year=date.getFullYear();
        const month=String(date.getMonth()+1).padStart(2,'0');
        const dayNumber=String(date.getDate()).padStart(2,'0');
        const iso=`${year}-${month}-${dayNumber}`;
        const key=`${item.variant_id || item.title}-${iso}`;

        button.innerHTML=`<strong>${escapeHtml(item.title)}</strong><br>${escapeHtml(item.time||'')}<br>${formatMoney(item.price)}`;

        if(!item.connected || !item.variant_id){
          button.classList.add('is-preview');
          button.disabled=true;
          button.title='Connect this class product in Theme settings to enable booking.';
        }else{
          button.addEventListener('click',()=>{
            const index=selected.findIndex(selectedItem=>selectedItem.key===key);
            if(index>=0){
              selected.splice(index,1);
              button.classList.remove('is-selected');
            }else{
              selected.push({...item,key,date:iso});
              button.classList.add('is-selected');
            }
            updateSelectionSummary();
          });
        }

        day.appendChild(button);
      });

      grid.appendChild(day);
    }

    updateSelectionSummary();

    addButton?.addEventListener('click',async()=>{
      if(!selected.length){
        if(summary) summary.textContent='Choose at least one class first.';
        return;
      }

      const items=selected.map(item=>({
        id:Number(item.variant_id),
        quantity:1,
        properties:{
          'Class name':item.title,
          'Class date':item.date,
          'Class time':item.time||''
        }
      }));

      try{
        const response=await fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items})
        });

        if(!response.ok){
          if(summary) summary.textContent='Could not add classes. Check product availability.';
          return;
        }

        selected.length=0;
        qa('.tdc-calendar-event.is-selected',calendar).forEach(button=>button.classList.remove('is-selected'));
        updateSelectionSummary();
        openCart();
      }catch(error){
        if(summary) summary.textContent='Could not add classes. Please try again.';
      }
    });
  });

  // History arrows on subpages
  qa('[data-history-back]').forEach(button=>button.addEventListener('click',()=>history.back()));
  qa('[data-history-forward]').forEach(button=>button.addEventListener('click',()=>history.forward()));

  refreshCart();
})();
